import { UserTypes } from "../../../interfaces";
import { axios } from "../../../lib/axios";
import { API_ROUTES } from "../../../lib/constants";


export const list = (params: any): Promise<any> => {
	return axios.get(
		API_ROUTES.CUSTOMERS.LIST,
		{ params }
	);
}

export const update = (paylaod: UserTypes.UserUpdatePayload): Promise<UserTypes.UserListResponse> => {
	return axios.patch(
		API_ROUTES.USERS.LIST,
		paylaod
	);
}


export const specificCMS = (type: number): Promise<any> => {
	return axios.get(
		"/cms",
		{ params: { type } }
	);
}


export const addUser = (payload: any): Promise<any> => {
	return axios.post(
		API_ROUTES.USERS.LIST,
		payload
	);
}
export const updateUser = (id: any, payload: any): Promise<any> => {
	return axios.put(
		API_ROUTES.USERS.LIST + `/${id}`,
		payload
	);
}

export const updateOrder = (id: any, payload: any): Promise<any> => {
	return axios.put(
		`${API_ROUTES.ORDERS.UPDATE}/${id}`,
		payload
	);
}

export const getIccidByVariant = (variantId: any): Promise<any> => {
	return axios.get(
		`${API_ROUTES.ICCID.BY_VARIANT}/${variantId}`
	);
}